<!-- Number input component for SSN, OTP, etc -->
<template>
  <div
    class="tw-w-full tw-flex"
    :class="{
      'tw-space-x-2': ['F3v1', 'F3v2', 'G', 'H', 'J', '1225-onboarding-core-v1', 'K'].includes(onboardingVariant),
      'tw-space-x-4': !['F3v1', 'F3v2', 'G', 'H', 'J', '1225-onboarding-core-v1', 'K'].includes(onboardingVariant)
    }"
    @input="handleInput"
  >
    <template
      v-for="field in fields"
    >
      <input
        :key="field"
        ref="firstDigit"
        v-model="digits[field - 1]"
        type="tel"
        maxlength="1"
        class="
          tw-border
          tw-bg-stone-50
          tw-rounded 
          focus-visible:tw-outline-lavender-purple
          active:tw-outline-lavender-purple
          tw-text-center
          tw-text-4xl
          tw-text-[#7F7F7F]
        "
        :class="{
          'tw-w-[70px] tw-h-[90px]': !isOnboardingRedesign,
          '!tw-w-[77px] !tw-h-[77px]': newOnboardingVariants,
          'tw-size-16 focus:tw-border-[#1A6A72] tw-outline-[0] tw-border-slate-300': isOnboardingRedesign,
          'tw-border-lavender-purple': !isOnboardingRedesign && digits[field - 1],
          'tw-border-slate-300': !isOnboardingRedesign && !digits[field - 1]
        }"
        @paste="field === 1 && handlePaste($event)"
      >
    </template>
  </div>  
</template>

<script>
import { mapState } from 'vuex';
export default {
  props: {
    fields: {
      type: Number,
      default: 4,
    },
  },
  data() {
    return {
      digits: [],
    }
  },
  computed: {
    ...mapState('global', ['isOnboardingRedesign']),
    ...mapState('onboarding', ['onboardingPatient']),
    onboardingVariant() {
      return this.onboardingPatient?.flow_variant;
    },
    newOnboardingVariants() {
      return ['D1', 'D2', 'E1', 'F3v1', 'F3v2', 'G', 'H', 'J', '1225-onboarding-core-v1', 'K'].includes(this.onboardingVariant);
    },
  },
  watch: {
    digits: {
      handler() {
        this.$emit('output', this.digits.join(''))
      },
      deep: true,
    }
  },
  methods: {
    handleInput(e) {
      if (e.data && e.target.nextElementSibling) {
        e.target.nextElementSibling.focus();
      } else if (e.data == null && e.target.previousElementSibling) {
        e.target.previousElementSibling.focus();
      }
    },
    handlePaste(e) {
      const pasteData = e.clipboardData.getData('text');
      let nextEl = this.$refs.firstDigit[0].nextElementSibling;
      for (let i = 1; i < pasteData.length; i++) {
        if (nextEl) {
          this.digits[i] = pasteData[i];
          nextEl = nextEl.nextElementSibling;
        }
      }
    }
  }
}
</script>